module.exports = __webpack_public_path__ + "static/media/ic_arrow.6bf3b288.svg";